module.exports = __webpack_public_path__ + "static/media/Bie.39847455.PNG";